import { FileItemType } from '@platform-ui-kit/components-library'

export interface ImportEventsModalFormValues {
  eventsFiles: [FileItemType?]
}

export const getDefaultValues = (): ImportEventsModalFormValues => ({
  eventsFiles: [],
})
